import React from 'react';
/* eslint-disable-next-line no-restricted-imports*/
import { Step, StepLabel, Stepper as MuiStepper } from '@mui/material';

export interface StepperStep {
  label: string;
}

interface Props {
  steps: StepperStep[];
  activeStep: number;
}

const Stepper = ({ steps, activeStep }: Props) => {
  return (
    <MuiStepper
      activeStep={activeStep}
      data-test-id='stepper'
    >
      {steps.map((step, index) => {
        return (
          <Step key={step.label} active={activeStep === index} data-test-id='step'>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        );
      })}
    </MuiStepper >
  );
};

export default Stepper;
